import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';

export default function Navigation() {
  const { currentUser, userRole, userData, logout } = useAuth();
  const navigate = useNavigate();
  const { cart, clearCart } = useCart();

  const handleLogout = async () => {
    try {
      await logout();
      clearCart(true);
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <Link to="/">MyStore</Link>
      </div>
      
      <div className="nav-links">
        {currentUser ? (
          <>
            <Link to="/home">Home</Link>
            <Link to="/shop">Shop</Link>
            {userRole === 'admin' && (
              <Link to="/admin-dashboard">Admin Dashboard</Link>
            )}
            <Link to="/cart" className="nav-cart" aria-label="Cart">
              🛒 <span className="nav-cart-count">{cart?.items?.length || 0}</span>
            </Link>
            <div className="nav-user">
              <span>Welcome, {userData?.username || currentUser.email}</span>
              <button onClick={handleLogout} className="logout-button">
                Logout
              </button>
            </div>
          </>
        ) : (
          <>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
            <Link to="/cart" className="nav-cart" aria-label="Cart">
              🛒 <span className="nav-cart-count">{cart?.items?.length || 0}</span>
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
